/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { camelCase, startCase } from 'lodash';

import { useLocation } from 'js/lib/useRouter';
import type UserAgentInfo from 'js/lib/useragent';

import { Grid, PageGridContainer } from '@coursera/cds-core';

import ContentBlock from 'bundles/seo-entity-page/components/ContentBlock';
import EntityPageBreadcrumbs from 'bundles/seo-entity-page/components/EntityPageBreadcrumbs';

import _t from 'i18n!nls/seo-entity-page';

type Props = {
  userAgent?: UserAgentInfo;
  contentBlock?: {
    label: string;
    content: string;
  };
};

const styles = {
  headerContainer: css`
    background-color: var(--cds-color-grey-100);
  `,
  header: css`
    padding: var(--cds-spacing-400) 0 var(--cds-spacing-300);

    @media (max-width: 600px) {
      padding: var(--cds-spacing-150) 0;
    }
  `,
};

export const EntityPageHeader = ({ userAgent, contentBlock }: Props) => {
  const { query: queryParams } = useLocation();
  let searchKeyword = 'Coursera';
  if (queryParams?.query) {
    searchKeyword = startCase(camelCase(queryParams.query));
  }

  const breadcrumbItems = [
    {
      href: 'browse',
      title: _t('Browse'),
    },
    {
      href: null,
      title: searchKeyword,
    },
  ];

  return (
    <div className="rc-EntityPageHeader" css={styles.headerContainer}>
      <PageGridContainer maxWidth="lg">
        <Grid item xs={12}>
          <header css={styles.header}>
            <EntityPageBreadcrumbs breadcrumbItems={breadcrumbItems} userAgent={userAgent} />
            {contentBlock && (
              <ContentBlock label={contentBlock.label} content={contentBlock.content} data-testid="top-content-block" />
            )}
          </header>
        </Grid>
      </PageGridContainer>
    </div>
  );
};

export default EntityPageHeader;
